import React from "react";
import { Container, Spinner, Tabs, Tab } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import Header from "../../Common/Header";
import { user_token } from "../../../_helpers/tokensStored";
import useAllAppliedMentor from "./useAllAppliedMentor";
import { useNavigate } from "react-router-dom";
import MainLayout from "../../Common/MainLayout";

export default (props) => {
  const userToken = user_token;
  const navigate = useNavigate();

  const {
    loading,
    appliedMentors,
    assignedMentors,
    onBackClick,
    onViewMentorProfileClick,
    onViewJobsDetail,
  } = useAllAppliedMentor(props);

  return (
    <MainLayout pageName={"Applied Mentors"}>
      <div className="hiring-process-dashboard">
        {loading ? (
          <div className="d-flex justify-content-center align-items-center">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : (
          <Container className="d-flex justify-content-between align-items-center">
            <div className="left">
              <h2 className="text-dark">
                <button className="border-0 bg-transparent mr-2">
                  <FontAwesomeIcon
                    icon={faAngleLeft}
                    className="text-primary"
                    onClick={onBackClick}
                  />
                </button>
                {userToken?.user &&
                  userToken.user.user_meta_info?.company_details &&
                  userToken.user.user_meta_info.company_details?.name}
              </h2>
            </div>
            <a href="/create-job" className="btn btn-primary">
              Create a new job
            </a>
          </Container>
        )}

        <div className="hiring-board mt-3">
          <div className="panel-right ml-3">
            <Tabs defaultActiveKey="AllAppliedMentors" className="video-tabs">
              <Tab eventKey="AllAppliedMentors" title="Applied Mentors">
                <div className="container">
                  <div className="d-flex align-items-center mt-4">
                    <h4
                      className="mb-4 mt-3 text-uppercase mr-3 flex-1"
                      style={{ width: "200px" }}
                    >
                      All Applied mentors
                    </h4>
                    <span className="partition border-bottom mb-2 w-100"></span>
                  </div>
                  <div className="job-listing">
                    {Array.isArray(appliedMentors) && appliedMentors?.length ? (
                      <div className="row">
                        {appliedMentors &&
                          Array.isArray(appliedMentors) &&
                          appliedMentors.map((data, index) => (
                            <div className="col-md-6  mb-4" key={index}>
                              <div className="d-flex flex-column h-100 p-4 bg-white border rounded-lg shadow-2 position-relative">
                                <div className="upper mb-3">
                                  <div className="d-flex mb-3 align-items-start">
                                    <img
                                      src={
                                        data?.mentor_profile_details &&
                                        data.mentor_profile_details
                                          ?.user_meta_info &&
                                        data.mentor_profile_details
                                          .user_meta_info?.profile_image
                                          ? data?.mentor_profile_details &&
                                            data.mentor_profile_details
                                              ?.user_meta_info &&
                                            data.mentor_profile_details
                                              .user_meta_info?.profile_image
                                          : "/assets/images/building-placeholder.png"
                                      }
                                      alt="profile_image"
                                      className="border-radius-10 mr-3"
                                      style={{ width: "48px", height: "48px" }}
                                    />
                                    <div className="job-info flex-grow-1">
                                      <h3
                                        className=" mb-1 text-capitalize text-primary cursor-pointer"
                                        onClick={() =>
                                          onViewMentorProfileClick(data.id)
                                        }
                                      >
                                        {data?.mentor_profile_details &&
                                          data.mentor_profile_details
                                            ?.user_details &&
                                          data.mentor_profile_details
                                            .user_details?.full_name}
                                      </h3>
                                      <p className="font-weight-medium text-grey-4 text-capitalize">
                                        {data?.mentor_profile_details &&
                                          data.mentor_profile_details?.headline}
                                      </p>
                                    </div>
                                  </div>
                                  <p className="skills-list">
                                    <span className="mr-2 font-weight-semi">
                                      Skills:
                                    </span>
                                    {data?.mentor_profile_details &&
                                    data.mentor_profile_details?.skills &&
                                    Array.isArray(
                                      data?.mentor_profile_details?.skills
                                    ) &&
                                    data.mentor_profile_details.skills.length >
                                      1 ? (
                                      <>
                                        {Array.isArray(
                                          data?.mentor_profile_details &&
                                            data.mentor_profile_details
                                              ?.skills &&
                                            data.mentor_profile_details.skills
                                        ) &&
                                          data?.mentor_profile_details &&
                                          data.mentor_profile_details?.skills &&
                                          data.mentor_profile_details.skills
                                            .slice(0, 7)
                                            .map((skill) => (
                                              <span className="skill text-muted">
                                                {skill?.skill_name}
                                              </span>
                                            ))}
                                        <p className="text-muted d-inline-block">
                                          {data?.mentor_profile_details &&
                                          data.mentor_profile_details?.skills &&
                                          Array.isArray(
                                            data.mentor_profile_details.skills
                                          ) &&
                                          data.mentor_profile_details.skills
                                            .length > 7
                                            ? "..."
                                            : null}
                                        </p>
                                      </>
                                    ) : (
                                      <>Not Specified</>
                                    )}
                                  </p>
                                  <p className="text-grey-4 text-capitalize pb-3">
                                    {data?.mentor_profile_details &&
                                      Array.isArray(
                                        data.mentor_profile_details
                                          ?.work_experience
                                      ) &&
                                      data.mentor_profile_details?.work_experience.map(
                                        (item) =>
                                          item?.currently_working_here ===
                                          true ? (
                                            <>
                                              <span className="mr-2 font-weight-semi text-dark-2">
                                                Currently Working:
                                              </span>
                                              {item?.company_name}
                                            </>
                                          ) : null
                                      )}
                                  </p>
                                </div>
                                <div className="d-flex justify-content-between align-items-center job-bottom mt-auto pt-3 border-top">
                                  <p className="text-grey-4">
                                    Applied for{" "}
                                    <span
                                      className="text-primary text-underline cursor-pointer"
                                      onClick={() =>
                                        onViewJobsDetail(
                                          data?.job_details &&
                                            data.job_details?.id
                                        )
                                      }
                                    >
                                      {data?.job_details &&
                                        data.job_details?.title}
                                    </span>
                                  </p>
                                  <button
                                    className="btn btn-primary py-2 mr-2"
                                    onClick={() =>
                                      onViewMentorProfileClick(data?.id)
                                    }
                                  >
                                    View
                                  </button>
                                </div>
                              </div>
                            </div>
                          ))}
                      </div>
                    ) : (
                      <div className="msg-bg text-white p-3 border-6 mb-3 mt-4 d-flex align-items-center justify-content-center mb-2 mw-50 mx-auto">
                        <p className="mb-0">
                          <FontAwesomeIcon
                            icon={faCircleInfo}
                            className="text-white mr-2"
                          />
                          No Applied Mentors Found
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </Tab>
              <Tab eventKey="AllAssignedMentors" title="Assigned Mentors">
                <div className="container">
                  <div className="d-flex align-items-center mt-4">
                    <h4
                      className="mb-4 mt-3 text-uppercase flex-1"
                      style={{ width: 240 }}
                    >
                      All Assigned mentors
                    </h4>
                    <span className="partition border-bottom mb-2 w-100"></span>
                  </div>
                  <div className="job-listing">
                    {Array.isArray(assignedMentors) &&
                    assignedMentors?.length ? (
                      <div className="row">
                        {assignedMentors &&
                          Array.isArray(assignedMentors) &&
                          assignedMentors.map((data, index) => (
                            <div className="col-md-6  mb-4" key={index}>
                              <div className="d-flex flex-column p-4 bg-white border position-relative h-100 rounded-lg shadow-2">
                                <div className="upper mb-3">
                                  <div className="d-flex mb-3 align-items-start">
                                    <img
                                      src={
                                        data?.mentor_profile_details &&
                                        data.posted_by_details
                                          ?.company_details &&
                                        data.posted_by_details.company_details
                                          ?.logo
                                          ? data?.posted_by_details &&
                                            data.posted_by_details
                                              ?.company_details &&
                                            data.posted_by_details
                                              .company_details?.logo
                                          : "/assets/images/building-placeholder.png"
                                      }
                                      alt="company logo"
                                      className="border-radius-10 mr-3"
                                      style={{ width: "48px", height: "48px" }}
                                    />
                                    <div className="job-info flex-grow-1">
                                      <h3 className=" mb-1 text-capitalize text-primary">
                                        {data?.title}
                                      </h3>
                                      <p className="mb-1 fs-14 text-capitalize">
                                        <span className="text-grey-4">
                                          {data?.city_name}
                                          {data?.city_name ? ", " : null}
                                          {data?.state_name}
                                          {data?.city_name ? ", " : null}
                                        </span>
                                        <span className="text-uppercase text-grey-4">
                                          {data?.country_name}
                                        </span>
                                      </p>
                                    </div>
                                  </div>

                                  <div className="d-flex align-items-center flex-wrap fs-smallest mb-3 justify-content-between">
                                    <div className="col-12 px-0 align-items-center d-flex justify-content-between">
                                      <p className="mb-0 text-grey-4  text-capitalize  mr-2  px-0 col-6">
                                        Applied:{" "}
                                        <span className="font-weight-medium text-dark">
                                          {data?.candidates_at_different_stages &&
                                            data.candidates_at_different_stages
                                              ?.applied}
                                        </span>
                                      </p>
                                      <p className="mb-0 text-grey-4  text-capitalize  mr-2  px-0 col-6">
                                        assessment:{" "}
                                        <span className="font-weight-medium text-dark">
                                          {data?.candidates_at_different_stages &&
                                            data.candidates_at_different_stages
                                              ?.assessment}
                                        </span>
                                      </p>
                                    </div>
                                    <div className="col-12 px-0 align-items-center d-flex justify-content-between">
                                      <p className="mb-0 text-capitalize text-grey-4   mr-2  px-0 col-6">
                                        Interview:{" "}
                                        <span className="font-weight-medium text-dark">
                                          {data?.candidates_at_different_stages &&
                                            data.candidates_at_different_stages
                                              ?.interview}
                                        </span>
                                      </p>
                                      <p className="mb-0 text-capitalize text-grey-4 text-grey-4  mr-2  px-0 col-6">
                                        offer:{" "}
                                        <span className="font-weight-medium text-dark">
                                          {data?.candidates_at_different_stages &&
                                            data.candidates_at_different_stages
                                              ?.offer}
                                        </span>
                                      </p>
                                    </div>
                                    <div className="col-12 px-0 align-items-center d-flex justify-content-between">
                                      <p className="mb-0 text-capitalize text-grey-4 mr-2 px-0 col-6">
                                        hired :{" "}
                                        <span className="text-dark font-weight-medium">
                                          {data?.candidates_at_different_stages &&
                                            data.candidates_at_different_stages
                                              ?.hired}
                                        </span>
                                      </p>
                                      <p className="mb-0 text-capitalize text-grey-4 mr-2 px-0 col-6">
                                        rejected:{" "}
                                        <span className="text-dark font-weight-medium">
                                          {data?.candidates_at_different_stages &&
                                            data.candidates_at_different_stages
                                              ?.rejected}
                                        </span>
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div className="d-flex justify-content-between align-items-center mt-auto border-top pt-3 flex-md-wrap flex-lg-nowrap">
                                  {data?.mentor_name === null ? (
                                    <>
                                      <p
                                        className="mb-0 mr-2  text-primary cursor-pointer"
                                        onClick={() =>
                                          navigate(
                                            `/view-mentors-applied/${data?.id}`,
                                            {
                                              state: data?.id,
                                            }
                                          )
                                        }
                                      >
                                        Mentors Applied:{" "}
                                        <span className="text-underline">
                                          {data?.total_mentors}
                                        </span>
                                      </p>
                                    </>
                                  ) : (
                                    <>
                                      <p className="mb-0 mr-2 text-grey-4 cursor-pointer">
                                        <span
                                          className="text-primary text-underline mr-1"
                                          onClick={() => {
                                            navigate(
                                              `/view-mentor-profile/${data?.mentor_job_application_id}`,
                                              {
                                                state: {
                                                  id: data?.mentor_job_application_id,
                                                  jobTitle: data?.title,
                                                },
                                              }
                                            );
                                          }}
                                        >
                                          {data?.mentor_name}{" "}
                                        </span>
                                        is assigned.
                                      </p>
                                    </>
                                  )}

                                  <div className="job-bottom mt-0 mt-md-3 mt-lg-0">
                                    <button
                                      className="btn btn-primary py-2 mr-2"
                                      onClick={(e) => {
                                        navigate(
                                          `/hiring-manager-kanboard/${data.id}`,
                                          {
                                            state: data?.id,
                                          }
                                        );
                                      }}
                                    >
                                      View
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                      </div>
                    ) : (
                      <div className="msg-bg text-white p-3 border-6 mb-3 mt-4 d-flex align-items-center justify-content-center mb-2 mw-50 mx-auto">
                        <p className="mb-0">
                          <FontAwesomeIcon
                            icon={faCircleInfo}
                            className="text-white mr-2"
                          />
                          No Assigned Mentors Found
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </Tab>
            </Tabs>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};
